// extracted by mini-css-extract-plugin
export default {"footerSection":"materials-tab_footerSection__yBpNH"};